import { render, staticRenderFns } from "./TableRegime.vue?vue&type=template&id=83a7f9e8"
import script from "./TableRegime.vue?vue&type=script&lang=js"
export * from "./TableRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a7f9e8')) {
      api.createRecord('83a7f9e8', component.options)
    } else {
      api.reload('83a7f9e8', component.options)
    }
    module.hot.accept("./TableRegime.vue?vue&type=template&id=83a7f9e8", function () {
      api.rerender('83a7f9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/rate_tables/views/TableRegime.vue"
export default component.exports